import {API, Auth} from 'aws-amplify';
import {User} from '../../entity/model/user';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {RequestBody} from '../../entity/core/request-body';
import {UserOnboardResponseDto} from '../../entity/dto/user-onboard-response-dto';
import {UserInvitationDto} from '../../entity/dto/user-invitation-dto';

export default class UserAgent {

  getCurrentUser = async (): Promise<User> => {
    const awsUser = await Auth.currentAuthenticatedUser();
    return await API.get(awsApiName, `/users/${awsUser.username}`, {});
  }

  getUserById = async (userId: string): Promise<User> => {
    return await API.get(awsApiName, `/users/${userId}`, {});
  }

  getAllUsers = async (organizationID: string): Promise<User[]> => {
    return API.get(awsApiName, `/organizations/${organizationID}/users`, {})
  }

  createUser = async (organizationID: string, requestBody: RequestBody): Promise<User> => {
    return API.post(awsApiName, `/organizations/${organizationID}/users`, requestBody);
  }

  updateUser = async (organizationID: string, userId: string, requestBody: RequestBody): Promise<User> => {
    return API.patch(awsApiName, `/organizations/${organizationID}/users/${userId}`, requestBody);
  }

  deleteUser = async (organizationID: string, userId: string): Promise<void> => {
    return API.del(awsApiName, `/organizations/${organizationID}/users/${userId}`, {});
  }

  detachUser = async (organizationID: string, userId: string): Promise<User> => {
    return API.post(awsApiName, `/organizations/${organizationID}/users/${userId}/detach`, {});
  }

  onboardUser = async (userId: string, requestBody: RequestBody): Promise<UserOnboardResponseDto> => {
    return API.post(awsApiName, `/users/${userId}/onboarding`, requestBody);
  }

  sendInvitation = async (organizationID: string, requestBody: RequestBody): Promise<UserInvitationDto> => {
    return API.post(awsApiName, `/organizations/${organizationID}/user-invitations`, requestBody);
  }

  getUserInvitations = async (organizationID: string): Promise<UserInvitationDto[]> => {
    return API.get(awsApiName, `/organizations/${organizationID}/user-invitations`, {});
  }

  resendInvitation = async (organizationID: string, invitationId: string): Promise<UserInvitationDto> => {
    return API.post(awsApiName, `/organizations/${organizationID}/user-invitations/${invitationId}/resend`, {});
  }

  deleteInvitation = async (organizationID: string, invitationId: string): Promise<void> => {
    return API.del(awsApiName, `/organizations/${organizationID}/user-invitations/${invitationId}`, {});
  }

  acceptInvitation = async (invitationCode: string, firstName: string, lastName: string): Promise<any> => {
    const requestBody = { body: { firstName, lastName } };
    return API.post(awsApiName, `/user-invitations/${invitationCode}/accept`, requestBody);
  }
}
